<template>
  <div class="contract-form">
    <div class="addContend">
      <!--      基本信息-->
      <el-card class="mb10">
        <template #header>
          <div class="card-header">
            <span>{{ $t('basicData.UnderlyingData') }}</span>
          </div>
        </template>
        <BasicForm ref="basicForm" :form-data="params" :type="type" />
      </el-card>
      <!--      业务信息-->
      <el-card class="mb10">
        <template #header>
          <div class="card-header">
            <span>{{ $t('basicData.BusinessInformation') }}</span>
          </div>
        </template>
        <div v-if="!params.businessList.length" class="add" @click="addBusiness">
          <i class="el-icon-folder-add" />
          {{ $t('basicData.ClickHereToAddBusinessInformation') }}</div>
        <BasicTable v-else ref="basicTable" :table-data="params.businessList" />
      </el-card>
      <!--      扫描件-->
      <el-card>
        <template #header>
          <div class="card-header">
            <span>{{ $t('basicData.ScannedDocuments') }}</span>
          </div>
        </template>
        <div v-if="!params.fileList.length" class="el-upload">
          <UploadCmp
            :drag="true"
            :auto-upload="true"
            :show-file-list="false"
            :is-check-file-type="true"
            :file-size="50"
            :limit="1"
            :upload-text="$t('basicData.SupportedFileFormats')"
            @change="onFileChange"
          />
        </div>
        <ScanTable
          v-else :id="params.id" ref="scanTable"
          :table-data="params.fileList"
          @close="cancel"
        />
      </el-card>
    </div>

    <div class="addFooter">
      <!--取消-->
      <el-button size="small" @click="cancel">{{ $t('basicData.Cancel') }}</el-button>
      <!--保存-->
      <el-button
        v-permit:remove="'btn:basicData:contractLedger:edit'" size="small" type="primary"
        @click="submitForm"
      >{{ $t('basicData.Save') }}</el-button>
    </div>
  </div>
</template>

<script>
import { apiContractAdd, apiContractGet, apiContractUpdate } from '@/api/finance/contractLedger';
import UploadCmp from '@/views/claimsManagement/claimStatement/cmp/UploadCmp.vue';
import { cloneDeep } from 'lodash-es';

export default {
  components: {
    UploadCmp,
    BasicForm: () => import('./basicForm.vue'),
    BasicTable: () => import('./basicTable.vue'),
    ScanTable: () => import('./scanTable.vue')
  },

  props: {
    rows: { // 详情
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 1 // 1: 新增 2: 修改
    }
  },

  data() {
    return {
      params: this.getInitialParams()
      // fileType: [
      //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      //   'image/jpeg',
      //   'image/png',
      //   'application/pdf'
      // ]
    };
  },

  watch: {
    // 监听rows变化，支持动态数据回显
    rows: {
      handler(newVal) {
        console.log('初始化:', newVal);
        this.initFormData();
      },
      deep: true,
      immediate: true // 改为true，确保首次也能执行
    }
  },

  methods: {
    // 获取初始参数对象
    getInitialParams() {
      return {
        contractNo: '', // 合同编号
        customerId: null, // 客户编号
        type: null, // 合同类型
        startDate: '', // 合同开始日期
        endDate: '', // 合同结束日期
        paymentDays: null, // 付款账期
        reconciliationStatus: null, // 可对账状态
        status: null, // 合同状态
        remark: '', // 备注
        businessList: [], // 业务信息
        fileList: [] // 扫描件
      };
    },

    // 初始化表单数据（用于编辑/查看时回显）
    initFormData() {
      this.resetForm();
      const { id } = this.rows;
      if (this.type !== 1 && id) {
        this.detail(id);
      } else {
        console.log('初始化新增');
        this.params = this.getInitialParams();
      }
    },

    // 重置表单数据为初始状态
    resetForm() {
      // 初始化表单数据
      this.params = this.getInitialParams();
      // 清除子组件的验证状态和数据
      this.$nextTick(() => {
        // 清除基础表单验证和数据
        if (this.$refs.basicForm) {
          this.$refs.basicForm.resetValidate();
        }

        // 清除业务表格组件状态
        if (this.$refs.basicTable) {
          this.$refs.basicTable.clearSelection();
        }

        // 清除扫描文件表格组件状态
        if (this.$refs.scanTable) {
          this.$refs.scanTable.clearSelection();
        }
      });
    },

    // 新增业务信息
    addBusiness() {
      const newItem = {
        businessType: [],
        businessContact: [],
        billCreator: [],
        billAuditor: []
      };
      this.params.businessList.push(newItem);

      // 新增后清除可能的表单验证状态
      this.$nextTick(() => {
        if (this.$refs.basicTable && this.$refs.basicTable.clearValidate) {
          this.$refs.basicTable.clearValidate();
        }
      });
    },

    // 上传扫描件
    onFileChange(Files) {
      console.log('上传扫描件', Files);

      if (!Files.length) {
        return;
      }

      // 获取当前时间 年月日 时分秒
      const now = new Date();
      const uploadTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

      // 更新扫描件
      this.params.fileList = Files.map(file => ({
        fileOriginalName: file.name,
        filePath: file.url,
        uploadTime,
        status: 0 // 0 生效 1 失效
      }));
    },

    // 详情
    detail(id) {
      apiContractGet(id).then(res => {
        console.log('合同详情:', res);

        const { code, data } = res;
        if (code !== 200) {
          return;
        }
        this.params = {
          ...data,
          time: data.startDate ? [data.startDate, data.endDate] : [],
          businessList: data.businessList || [],
          fileList: data.fileList || []
        };
      }).catch(err => {
        console.log('详情错误:', err);
      });
    },

    // 取消
    cancel() {
      // 关闭前先重置表单数据
      this.resetForm();
      this.$emit('closeDetail');
    },

    // 保存
    async submitForm() {
      try {
        // 1. 校验基础信息，并获取最新数据
        console.log('开始校验基础信息...');
        const basicFormData = await this.$refs.basicForm.validate();
        console.log('基础信息校验通过，数据:', basicFormData);
        // 同步子组件的最新数据到父组件
        this.params = {
          ...this.params,
          ...basicFormData
        };
        delete this.params.time;
        console.log('同步后的 params:', this.params);

        // 2. 校验业务信息，并获取最新数据
        if (this.$refs.basicTable) {
          console.log('开始校验业务信息...');
          const businessData = await this.$refs.basicTable.validate();
          console.log('业务信息校验通过，数据:', businessData);

          // 同步业务信息数据
          this.params.businessList = businessData || [];
        }

        // 3. 校验扫描件
        if (this.$refs.scanTable) {
          console.log('开始校验扫描件...');
          const fileList = this.$refs.scanTable.getFileList();
          console.log('扫描件校验通过');

          // 同步扫描件数据
          this.params.fileList = fileList || [];
        }

        // 4. 所有校验通过，调用 API 保存
        console.log('所有校验通过，开始保存...');
        console.log('最终提交数据:', this.params);
        // const params = cloneDeep(this.params);
        // const list = params.businessList.map(item => ({
        //   ...item,
        //   businessContact: JSON.stringify(item.businessContact),
        //   billCreator: JSON.stringify(item.billCreator),
        //   billAuditor: JSON.stringify(item.billAuditor)
        // }));
        // params.businessList = list;
        const API = this.type === 1 ? apiContractAdd : apiContractUpdate;
        const res = await API(this.params);
        console.log('保存结果：', res);
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded') || '保存成功');
          // 先重置表单，再关闭弹窗
          this.resetForm();
          this.$emit('closeDetail');
        } else {
          this.$message.error(res.message || '保存失败');
        }
      } catch (error) {
        // 校验失败或 API 错误
        console.error('校验失败或保存出错:', error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.contract-form {
  padding: 10px 10px;

  ::v-deep.el-card__header {
    padding: 10px 20px !important;
  }

  .addContend {
    padding: 20px;
    height: calc(100vh - 100px);
    overflow-y: auto;
  }

  .addFooter {
    border-top: 1px solid #ccc;
    text-align: right;
    padding: 10px;
  }
}

.add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  background: #f5f5f5;

  .el-icon-folder-add,
  .el-icon-upload {
    font-size: 80px;
  }
}

.el-upload {
  width: 100%;

  div {
    width: 100%;

    ::v-deep .el-upload,
    ::v-deep .el-upload-dragger {
      width: 100%;
    }
  }
}
</style>
